import styled from 'styled-components';

const TableWrapper = styled.div`
  margin: ${({ margin }) => margin};
  box-shadow: 0px 7px 17px -7px rgba(11, 26, 33, 0.3);
  max-width: 100%;

  .mobile-logo {
    display: none;
  }

  .table--serviceTitanColumn-cell:before,
  .table--serviceTitanColumn-cell:after {
    content: ' ' !important;
    height: 100% !important;
    position: absolute !important;
    top: 0 !important;
    width: 15px !important;
  }

  .table--serviceTitanColumn-cell:before {
    box-shadow: -20px 0 20px -20px inset rgba(11, 26, 33, 0.15) !important;
    left: -15px !important;
    z-index: 1 !important;
    transform: inherit !important;
  }

  .table--serviceTitanColumn-cell:after {
    box-shadow: 20px 0 20px -20px inset rgba(11, 26, 33, 0.15) !important;
    right: -15px !important;
    z-index: 1 !important;
  }

  .MuiTable-root.st-table {
    thead .MuiTableCell-root {
      border-top: 13px solid white;
    }

    thead .table--serviceTitanColumn-cell {
      background: var(--titan-blue-3);
      padding: 15px 15px;
      border-top: 13px solid var(--titan-blue-3);

      @media (max-width: 767px) {
        padding: 15px;
      }
    }
  }

  .MuiTable-root thead {
    h6 {
      padding: 0;
      width: max-content;
      margin: 0 auto !important;
    }
    tr {
      th {
        background: var(--grey-6);
        padding: 18px 25px;
        text-align: center;
        border-bottom: 0;
        position: relative;

        @media (max-width: 767px) {
          padding: 10px;
        }

        &:first-child {
          text-align: left;
        }

        h6 {
          font-weight: var(--font-weight-500);
          font-size: var(--font-size-p-md);
          text-transform: uppercase;

          @media (max-width: 767px) {
            font-size: var(--font-size-16);
          }
        }
      }

      &:first-child {
        th:last-child,
        th:first-child {
          border-radius: 0px;
        }
      }
    }

    .table--st-logo {
      svg {
        height: 35px;
        margin-top: -10px;

        @media (max-width: 767px) {
          height: 25px;
        }
      }
    }
  }

  .MuiTableBody-root {
    tr {
      td {
        padding: 15px 25px;
        text-align: center;
        font-size: var(--font-size-16);
        font-family: var(--font-family-body);
        color: var(--darkest);
        border-left: 0.5px solid #f0f0f0;
        border-right: 0.5px solid #f0f0f0;
        border-bottom: 0.5px solid #f0f0f0;
        position: relative;

        b {
          font-family: var(--font-family-body);
        }
        @media (max-width: 767px) {
          padding: 10px 15px 8px 15px;
          font-size: var(--font-size-13);
          min-width: 100px;
        }

        @media (min-width: 768px) {
          width: 170px;
        }

        &:first-child {
          text-align: left;
        }
      }
      &:last-child {
        .table--serviceTitanColumn-cell {
          border-bottom: 2px solid var(--titan-blue-3);
        }
      }
    }
  }

  .table--subhead {
    background: var(--titan-blue-1);

    td {
      background: var(--titan-blue-1) !important;
      font-size: var(--font-size-p-md) !important;
      color: var(--darkest) !important;
      font-weight: 500;
      font-family: var(--font-family-heading);
    }
  }

  .table--zebra {
    background: rgba(196, 196, 196, 0.1);
  }

  .table--serviceTitanColumn-cell {
    border-left: 2px solid var(--titan-blue-3) !important;
    border-right: 2px solid var(--titan-blue-3) !important;
  }

  .table--serviceTitanColumn-cell + td {
    border-left: none !important;
  }

  @media (max-width: 575px) {
    .mobile-logo {
      display: block;
    }
    .desktop-logo {
      display: none;
    }
    .table--serviceTitanColumn-cell {
      max-width: 100px !important;
      min-width: 100px !important;
    }
    .table--st-logo {
      svg {
        height: 32px !important;
        width: 40px;
        margin: 0 auto;
      }
    }

    h6 {
      font-size: 13px !important;
    }

    .table--subhead {
      td {
        font-size: 13px !important;
      }
    }
  }
`;

const TableContainer = styled.div`
  h2 {
    text-align: center;
    margin-bottom: 50px;
  }
`;

export { TableContainer, TableWrapper };
